import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import utils from 'utils/Utils';
import {withStyles} from "@material-ui/core/styles";

const styles = {
    root: {},
};

const StyledKeyboardDatePicker = withStyles(styles)(({label, date, classes, handleChange, name, disabled}) => {
    return (
            <KeyboardDatePicker
                    name={name}
                    className={classes.root}
                    variant="inline"
                    margin="none"
                    id="date-picker-inline"
                    autoOk={true}
                    label={label}
                    value={date}
                    disabled={disabled}
                    fullWidth
                    format={utils.VIEW_DATE_FORMAT}
                    InputLabelProps={{ shrink: true }}
                    onChange={m => {
                        if(m?.isValid()) {
                            handleChange(name, m?.format(utils.API_LOCAL_DATE_FORMAT))
                        }
                    }}
                    KeyboardButtonProps={{
                        "aria-label": "change date",
                    }}
            />
    );
});

const StyledDatePicker = ({label, date, onChange, name, disabled}) => {
    return (
            <MuiPickersUtilsProvider utils={MomentUtils} locale="de">
                <StyledKeyboardDatePicker label={label} name={name} date={date} handleChange={onChange} disabled={disabled}/>
            </MuiPickersUtilsProvider>
    );
};

export default StyledDatePicker;
